// removed by extract-text-webpack-plugin
module.exports = {"kuku":"kuku","galtu_dasri":"galtu_dasri","cfari":"cfari","paragraph":"paragraph","translation":"translation","margin":"margin","forum":"forum","tapla":"tapla","desc":"desc","left":"left","right":"right","inner_list":"inner_list","jbo":"jbo","en":"en","ideas":"ideas","xamsel":"xamsel","docs":"docs","content-panel":"content-panel","ralju_pixra":"ralju_pixra","twitter":"twitter","bold":"bold","bar":"bar","wikitable":"wikitable","last":"last","pritupixra":"pritupixra","pixra":"pixra","pinka_lepixra":"pinka_lepixra","navbar-nav":"navbar-nav"};


//////////////////
// WEBPACK FOOTER
// ./client/styling/style.css
// module id = 3
// module chunks = 0